<template>
  <section>
    <h1>{{ $t("settings") }}</h1>
  </section>

  <div class="row">
    <div class="col-12 col-lg-6">
      <section class="mb-5">
        <h2>{{ $t("editProfile") }}</h2>

        <update-profile-form />
      </section>

      <section class="mb-5">
        <h2>{{ $t("editCredentials") }}</h2>

        <section>
          <button
            id="changeEmailCollapseController"
            :class="showChangeEmailForm ? 'btn-secondary' : 'btn-light'"
            aria-controls="changeEmailCollapse"
            aria-expanded="false"
            class="btn w-100 mb-4"
            data-bs-target="#changeEmailCollapse"
            data-bs-toggle="collapse"
            @click="toggleChangeEmailForm"
          >
            {{ $t("changeEmailAddress") }}
          </button>

          <div id="changeEmailCollapse" class="collapse">
            <change-email-form />
          </div>
        </section>

        <section>
          <button
            id="changePasswordCollapseController"
            :class="showChangePasswordForm ? 'btn-secondary' : 'btn-light'"
            aria-controls="changePasswordCollapse"
            aria-expanded="false"
            class="btn w-100"
            data-bs-target="#changePasswordCollapse"
            data-bs-toggle="collapse"
            @click="toggleChangePasswordForm"
          >
            {{ $t("changePassword") }}
          </button>

          <div id="changePasswordCollapse" class="collapse">
            <change-password-form />
          </div>
        </section>
      </section>

      <section>
        <h2>{{ $t("deleteAccount") }}</h2>

        <button
          id="deleteUserCollapseController"
          :class="showDeleteUserForm ? 'btn-secondary' : 'btn-light'"
          aria-controls="deleteUserCollapse"
          aria-expanded="false"
          class="btn w-100"
          data-bs-target="#deleteUserCollapse"
          data-bs-toggle="collapse"
          @click="toggleDeleteUserForm"
        >
          {{ $t("iWantToDeleteMyAccount") }}
        </button>

        <div id="deleteUserCollapse" class="collapse">
          <delete-profile />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import DeleteProfile from "../components/settings/DeleteProfile";
import UpdateProfileForm from "../components/settings/UpdateProfileForm";
import ChangePasswordForm from "../components/settings/ChangePasswordForm";
import ChangeEmailForm from "../components/settings/ChangeEmailForm";

import { Collapse } from "bootstrap";

export default {
  name: "Settings",
  components: {
    DeleteProfile,
    UpdateProfileForm,
    ChangePasswordForm,
    ChangeEmailForm,
  },

  data() {
    return {
      showChangeEmailForm: false,
      showChangePasswordForm: false,
      showDeleteUserForm: false,
    };
  },
  methods: {
    async toggleChangeEmailForm() {
      const emailElement = document.getElementById(
        "changeEmailCollapseController"
      );
      let emailExpanded = emailElement.getAttribute("aria-expanded");
      emailExpanded = emailExpanded === "true";
      this.showChangeEmailForm = emailExpanded;

      const passwordElement = document.getElementById(
        "changePasswordCollapseController"
      );
      let passwordExpanded = passwordElement.getAttribute("aria-expanded");
      passwordExpanded = passwordExpanded === "true";

      if (passwordExpanded) {
        const collapse = new Collapse(
          document.getElementById("changePasswordCollapse")
        );
        await collapse.toggle();

        this.showChangePasswordForm = false;
      }

      const userElement = document.getElementById(
        "deleteUserCollapseController"
      );
      let userExpanded = userElement.getAttribute("aria-expanded");
      userExpanded = userExpanded === "true";

      if (userExpanded) {
        const collapse = new Collapse(
          document.getElementById("deleteUserCollapse")
        );
        await collapse.toggle();

        this.showDeleteUserForm = false;
      }
    },
    async toggleChangePasswordForm() {
      const passwordElement = document.getElementById(
        "changePasswordCollapseController"
      );
      let passwordExpanded = passwordElement.getAttribute("aria-expanded");
      passwordExpanded = passwordExpanded === "true";
      this.showChangePasswordForm = passwordExpanded;

      const emailElement = document.getElementById(
        "changeEmailCollapseController"
      );
      let emailExpanded = emailElement.getAttribute("aria-expanded");
      emailExpanded = emailExpanded === "true";

      if (emailExpanded) {
        const collapse = new Collapse(
          document.getElementById("changeEmailCollapse")
        );
        await collapse.toggle();

        this.showChangeEmailForm = false;
      }

      const userElement = document.getElementById(
        "deleteUserCollapseController"
      );
      let userExpanded = userElement.getAttribute("aria-expanded");
      userExpanded = userExpanded === "true";

      if (userExpanded) {
        const collapse = new Collapse(
          document.getElementById("deleteUserCollapse")
        );
        await collapse.toggle();

        this.showDeleteUserForm = false;
      }
    },
    async toggleDeleteUserForm() {
      const userElement = document.getElementById(
        "deleteUserCollapseController"
      );
      let userExpanded = userElement.getAttribute("aria-expanded");
      userExpanded = userExpanded === "true";
      this.showDeleteUserForm = userExpanded;

      const emailElement = document.getElementById(
        "changeEmailCollapseController"
      );
      let emailExpanded = emailElement.getAttribute("aria-expanded");
      emailExpanded = emailExpanded === "true";

      if (emailExpanded) {
        const collapse = new Collapse(
          document.getElementById("changeEmailCollapse")
        );
        await collapse.toggle();

        this.showChangeEmailForm = false;
      }

      const passwordElement = document.getElementById(
        "changePasswordCollapseController"
      );
      let passwordExpanded = passwordElement.getAttribute("aria-expanded");
      passwordExpanded = passwordExpanded === "true";

      if (passwordExpanded) {
        const collapse = new Collapse(
          document.getElementById("changePasswordCollapse")
        );
        await collapse.toggle();

        this.showChangePasswordForm = false;
      }
    },
  },
};
</script>

<style scoped></style>
